/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { CornMill } from "./modelCornMill";

class ControllerCornMill extends ControllerModel {
  constructor() {
    super("ControllerCornMill");
    
    this.setNewNode = (callback) => {
      let cornMill = new CornMill();
      cornMill.decorate(callback);

      this.addNode(cornMill);
      SingletonFlowchart.SaveStatus();
    }

    this.loadNode = (node, callback) => {
      let cornMill = new CornMill();
      cornMill.copyFrom(node);
      cornMill.decorate(callback);
      this.addNode(cornMill)
    }

    this.getProperties = async (node) => {
      let n = new CornMill();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new CornMill();
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerCornMill };
